import { Button, Divider } from '@mui/material';
import React from 'react';
import { base_api_url } from '../services/httpService';
import { fileDownloader } from '../utils/fileDownloader';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';

const TicketContext = ({
    context,
    date,
    time,
    file,
    code,
    className
}) => {
    return (
        <div className={`rounded-lg border border-black
        overflow-hidden ${className || "w-full bg-gray-300"}`}>
            {context && (
                <div className="w-full p-4 break-words">
                    {context}
                </div>
            )}
            {file && (
                <div className="p-4">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => fileDownloader(`${base_api_url}/ticket_admin_panel/get_message_file/${code}/`)}>
                        دانلود
                        <span className="ms-1">
                            <DownloadRoundedIcon />
                        </span>
                    </Button>
                </div>
            )}
            <Divider sx={{
                background: "black"
            }} />
            <div className="w-full px-3 py-3 text-sm 
            flex justify-between items-center">
                <span className="me-2">
                    {date}
                </span>
                <span className="ms-2">
                    {time}
                </span>
            </div>
        </div>
    );
}

export default TicketContext;
